import React from "react";
import { Trans, useTranslation } from "react-i18next";
import { Container } from "reactstrap";

import ambassador1 from "../../../../media/legal/ambassador1.png";
import ambassador2 from "../../../../media/legal/ambassador2.png";

const TncPartner: React.FC = () => {
  const { t } = useTranslation("legal");
  return (
    <Container className="py-5 px-4 px-md-5 plainHtml bg-white">
      <Trans
        t={t}
        i18nKey={"tycPartner"}
        components={{
          br: <br />,
          h1: <h1 />,
          h2: <h2 />,
          h3: <h3 />,
          ol: <ol />,
          ul: <ul />,
          li: <li />,
          ol_type_a: <ol type="a" />,
          ol_type_A: <ol type="A" />,
          ol_type_I: <ol type="I" />,
          small: <small />,
          img1: <img src={ambassador1} alt="" style={{ maxWidth: "100%" }} />,
          img2: <img src={ambassador2} alt="" style={{ maxWidth: "100%" }} />,
        }}
      />
    </Container>
  );
};

export default TncPartner;
